import { api2, Auth } from "@services";

export const fetchDomain = () => api2.get(`/v1/company/domain`);

export const customizePage = form => {
    const role = Auth.role === 'trial_company' ? 'company' : Auth.role;
    return api2.post(`/v1/${role}/page/${Auth.user.id}`, form);
} 